/** Pure keyboard-nav helpers for Virtuoso difference lists. */

/** Prefer keyboard cursor; fall back to focused list index. */
export const resolveNavBaseIndex = (currentItemIndex: number, focusedListIndex: number): number => {
  if (currentItemIndex === -1 && focusedListIndex > -1) {
    return focusedListIndex;
  }
  return currentItemIndex;
};

/** Next navigable row in `direction`, or -1 if none. */
export const findNextNavigableIndex = (
  from: number,
  direction: 1 | -1,
  length: number,
  isNavigable: (index: number) => boolean,
): number => {
  let nextIndex = from;
  while (nextIndex >= 0 && nextIndex < length && !isNavigable(nextIndex)) {
    nextIndex += direction;
  }
  if (nextIndex < 0 || nextIndex >= length) {
    return -1;
  }
  return nextIndex;
};

/** 0-based difference number → Virtuoso list index (skips non-difference rows). */
export const mapDifferenceNumberToListIndex = (
  length: number,
  differenceNumber: number,
  isDifferenceRow: (index: number) => boolean,
): number => {
  let count = -1;
  for (let i = 0; i < length; i += 1) {
    if (isDifferenceRow(i)) {
      count += 1;
      if (count === differenceNumber) return i;
    }
  }
  return -1;
};
